<template>
 <div class="col-12">
   <div class="row" style="
    max-width: 95%;
    margin: auto;
">

      <card card-body-classes="table-full-width" style="box-shadow: initial;" no-footer-line>
            <div class="col-md-12 breadcumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/reclamaciones' }"
          >{{ $t("app.modules.complaints.title") }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $t("app.modules.complaints.buttons.add") }}</el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>
      </el-breadcrumb>

      <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
      
    </div>
    <el-divider></el-divider>
     <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.complaints.buttons.add") }}
            </h4>
          </div>
          <div style="
    max-width: 80%;
    margin: auto;
    padding-top: 20px;
">
<card>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewItem)">
        <div class="row">
          <div :class="sizes">
            <fg-input
              type="text"
              :label="$t('app.modules.complaints.headers.product')"
              v-model="item.producto"
            >
            </fg-input>
          </div>
          <div :class="sizes">
            <fg-input
              type="text"
              :label="$t('app.modules.complaints.headers.batch')"
              v-model="item.lote"
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div :class="sizes">
            <fg-input
              type="text"
              :label="$t('app.modules.complaints.headers.invoice')"
              v-model="item.factura"
            >
            </fg-input>
          </div>
          <div :class="sizes">
            <fg-input
              type="text"
              :label="$t('app.modules.complaints.headers.purchase_order')"
              v-model="item.odc"
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div :class="sizes">
            <fg-input
              type="text"
              :label="$t('app.modules.complaints.headers.order_numbre')"
              v-model="item.pedido"
            >
            </fg-input>
          </div>
          <div :class="sizes">
          <div class="form-group has-label">
            {{$t("app.modules.complaints.headers.description")}}
          </div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              name="minLength"
              :placeholder="$t('app.modules.complaints.headers.description')"
              v-model="item.descripcion"
            >
            </el-input>
          </div>
        </div>
        <div class="row">
          <div :class="sizes">
          <el-upload
                class="upload-demo"
                ref="upload"
                action="#"
                multiple
                accept="image/*, .pdf, .docx, .docs, .pptx"
                :file-list="fileList"
                :limit="5"
                :auto-upload="false"
                :on-change="handleFile"
                :on-remove="handleFile"
              >
                <n-button size="small" type="primary">{{ $t("app.upload.select_file") }}</n-button>
                <div slot="tip" class="el-upload__tip">{{ $t("app.upload.upload_formats") }}</div>
              </el-upload>

          </div>
        </div>
        <div class="row">
          <div :class="sizes">
              <h4>
              <small>
                  <b>{{ $t("app.modules.complaints.headers.claimant_name") }}</b>
              </small>
              </h4>
              <h5>
                  <small>{{ item.nombre }}</small>
              </h5>
          </div>
        </div>
        <div class="row">
          <div :class="sizes">
              <h4>
              <small>
                  <b>{{ $t("app.modules.complaints.headers.telephone") }}</b>
              </small>
              </h4>
              <h5>
                  <small>{{ item.telefono }}</small>
              </h5>
          </div>
          <div :class="sizes">
              <h4>
              <small>
                  <b>{{ $t("app.modules.complaints.headers.emai") }}</b>
              </small>
              </h4>
              <h5>
                  <small>{{ item.email }}</small>
              </h5>
          </div>
      </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelAdd">{{
              $t("app.buttons.cancel")
            }}</n-button>
          <n-button native-type="submit" type="primary">{{
              $t("app.modules.complaints.buttons.send")
            }}</n-button>
        </div>
      </form>
    </ValidationObserver>
    </card>
    </div>
      </card>
   </div>
 </div>
</template>
<script>
import { mapState } from "vuex";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";


extend("email", email);
extend("required", required);
extend("min", min);

export default {
  components: {},
  computed: {
    ...mapState(["user"])
  },
  data() {
    return {
      file_formats: "image/png, image/jpeg, image/gif, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation",
      sizes: "col-md-6 col-sm-12",
      selectIncompleto: false,
      enableSendButton: false,
      fileList: [],
      item: {
        idReclamacion:0,
        producto: '',
        lote: '',
        factura: '',
        odc: '',
        pedido: '',
        descripcion: '',
        UsuarioVendedor: 0,
        evidencias: [],
        telefono: ''
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modals: {
        classic: false,
        notice: false,
        mini: false
      },
    };
  },
  created() {
    console.log(this.user);
    this.item.nombre = !!this.user.nombre ? this.user.nombre : "N/A";
    this.item.email = !!this.user.correo ? this.user.correo : "";
    this.item.telefono = !!this.user.telefono ? this.user.telefono : "S/N";
    //console.log(this.user);
     //imagenComunicacion: null
  },
  async mounted() {
    EventBus.$on("reclamaciones-add", async () => {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getClientUser();
      this.$swal.close();
      this.modals.classic = true;
    });
    await this.initReclamacionesAdd();
  },
  methods: {
    async initReclamacionesAdd(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getClientUser();
      await this.getUserVendorByClienIdUser();
      console.log(this.item);
      this.$swal.close();
    },
    async getClientUser() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
        Estado: 0
      };

      await this.$http.post(route("Clientes/getContactosByClienteUserId"), params).then(
        response => {
          if (response.body.code === 200) {
            console.log(response.body.contactos);
            if(response.body.contactos.length > 0){
                console.log(response.body.contactos[0])
                this.item.contactoCliente_idContacto = response.body.contactos[0].idContacto;
                this.item.telefono = response.body.contactos[0].telefono;
            }
            else{
              this.notifyMessage("danger", this.$t("app.modules.complaints.messages.client_error"));
            }
          } else {
            console.log(response.body);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    async getUserVendorByClienIdUser() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
        Estado: 0
      };

      await this.$http.post(route("Usuarios/getUsuariosVendorByClientUserId"), params).then(
        response => {
          if (response.body.code === 200) {
            console.log(response.body.usuarios);
            if(response.body.usuarios.length > 0){
                this.item.UsuarioVendedor = response.body.usuarios[0].idUsuario;
            }else{
              this.notifyMessage("danger", this.$t("app.modules.complaints.messages.vendor_error"));
            }
          } else {
            console.log(response.body);
           this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    cancelAdd() {
      this.item.producto= '';
      this.item.lote= '';
      this.item.factura= '';
      this.item.odc= '';
      this.item.pedido= '';
      this.item.descripcion= '';
      this.item.ContactoCliente_idContacto= 0;
      this.item.retroalimentacion= '';
      this.item.reclamacion_idEstadoReclamacion= 1;
      this.item.evidenciaReclamaciones=null;
      this.item.usuarioVendor = 0;
      this.modals.classic = false;
      this.fileList= []
      this.$router.push({
                name: "Reclamaciones"
              });
    },
    async submitNewItem() {
        if(this.item.contactoCliente_idContacto < 1){
            this.notifyMessage("danger", this.$t("app.modules.complaints.messages.client_error"));
        } else if(this.item.usuarioVendor < 1){
               this.notifyMessage("danger", this.$t("app.modules.complaints.messages.vendor_error"));
        } else {
          this.$swal.fire({
            title: this.$t("app.promps.wait"),
            html:
              '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
            showConfirmButton: false
          });

          try {
            if(!!!this.item.descripcion) throw new Error(this.$t('app.modules.complaints.errors.no_description'));

            await this.addNewRow();
          }
          catch (e){
            this.notifyMessage('danger', e.message);
          }
          finally
          {
            this.$swal.close();
          }
      }
    },
    async addNewRow() {
      //var payload = {id: 0, claveIdioma: 'es',usuario:0, estado:0, reclamacion: this.item}
      //console.log(payload)
      let formData = new FormData();
      let obj = {
        idReclamacion: this.item.idReclamacion,
        producto: this.item.producto,
        lote: this.item.lote,
        factura: this.item.factura,
        odc: this.item.odc,
        pedido: this.item.pedido,
        descripcion: this.item.descripcion,
        UsuarioVendedor: this.item.UsuarioVendedor,
        ContactoCliente_idContacto: this.item.contactoCliente_idContacto,
        UsuarioVendedor: this.item.UsuarioVendedor
      }

      let data = new FormData();
      data.append("param", JSON.stringify(obj));

      if(this.item.evidencias.length > 0){
        for (const evidencia of this.item.evidencias) {
          data.append("evidencias", evidencia);
        }
      }
      /*formData.append("idReclamacion",this.item.idReclamacion)
      formData.append("producto",this.item.producto)
      formData.append("lote",this.item.lote)
      formData.append("factura",this.item.factura)
      formData.append("odc",this.item.odc)
      formData.append("pedido",this.item.pedido)
      formData.append("descripcion",this.item.descripcion)
      formData.append("contactoCliente_idContacto",this.item.contactoCliente_idContacto)
      formData.append("fechaRegistro",this.item.fechaRegistro)
      formData.append("retroalimentacion",this.item.retroalimentacion)
      formData.append("reclamacion_idEstadoReclamacion",this.item.reclamacion_idEstadoReclamacion)
      formData.append("ImagenComunicacion", "");
      formData.append("file", this.imagenComunicacion)*/
      for(var item of formData.values()){
        console.log(item)
      }
      await this.$http
        .post(route("Reclamaciones/postReclamacionAsClient"), data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
        )
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              this.cancelAdd();
              this.$router.push({
                name: "Reclamaciones"
              });
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    handleFile(file, fileList) {
      var correctFormats = true;
      this.item.evidencias = [];
      for(let f of fileList){
        let index = fileList.indexOf(f);
        if(f.raw !== undefined && f.raw.type !== ""){
          if(this.file_formats.includes(f.raw.type)){
            this.item.evidencias.push(f.raw);
          }else{
            fileList.splice(index, 1);
            correctFormats = false;
          }
        }else{
           fileList.splice(index, 1);
           correctFormats = false;
        }
      }
      if(!correctFormats){
        this.notifyMessage("warning", this.$t("app.upload.upload_formats"));
      }
    },
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
